import { Progress } from '@radix-ui/react-progress'
import { Clock } from 'lucide-react'
import React from 'react'

interface TimerProps {
  remainingTime: number
  timeLimit: number
  formatTime: (seconds: number) => string
  onStart?: () => void
}

export function Timer({ remainingTime, timeLimit, formatTime, onStart }: TimerProps) {
  React.useEffect(() => {
    if (onStart) {
      onStart()
    }
  }, [onStart])

  if (timeLimit <= 0) return null

  return (
    <div className="w-full max-w-md">
      <div className="mb-1 flex justify-between text-sm text-gray-600">
        <span className="flex items-center gap-1">
          <Clock className="h-4 w-4" /> Pozostały czas:
        </span>
        <span>{formatTime(remainingTime)}</span>
      </div>
      <Progress className="h-2" value={(remainingTime / timeLimit) * 100} />
    </div>
  )
}
